import { connect } from "react-redux";
import React, { useEffect, useState } from 'react';
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
import * as logger from '../../../logger';
import { vehicleMonthlyPnlReport } from '../../../store/actions/vehicleActionCreator';
import { vehicleMonthlyReportCss as useStyles } from './VehicleCss';
import RightSideBar from '../../components/RightSideBar/RightSideBar';
import { getVehicleNumberValuesDWeb, numberWithCommas, numberFormat } from '../../../utils/utils';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ReportsDialog from '../../components/ReportsDialog/ReportsDialog';

const SingleVehicleMonthlyReport = ({ vehicle, vehicleIdValue, open, onClose, dispatchGetMonthlyProfitLoss, singleTruck }) => {

    let submit, formValues;

    const [dialogOpen, setDialogOpen] = useState(false);
    const [vehicleNumberType, setVehicleNumberType] = useState({ vehicleNumberPrefix: "", vehicleNumberSuffix: "" });
    const [profitLossData, setProfitLossData] = useState([]);
    const [collapseKeys, setCollapseKeys] = useState({});
    const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
    const [pdfMonthValue, setPdfMonthValue] = useState("");

    const classes = useStyles();
    let vehicleId = vehicleIdValue

    useEffect(() => {

        let requestData = {
            "vehicleId": vehicleId,
            "pageSize": 12,
            "pageNo": 1
        }

        dispatchGetMonthlyProfitLoss(requestData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Vehicle Monthly Report Dweb", 'Get truck Monthly PandL successfull');
                    setDialogOpen(true);
                }
            },
            () => {
                logger.log("Single Vehicle Monthly Report Dweb", 'Get truck Monthly PandL failed');
            }
        );

        let vehicleNumberArray = getVehicleNumberValuesDWeb(singleTruck.vehicleNumber);

        const vehicleNumberSuffixValue = vehicleNumberArray && vehicleNumberArray.length > 0 ? vehicleNumberArray.pop() : "";
        const vehicleNumberPrefixValue = vehicleNumberArray && vehicleNumberArray.length > 0 ? vehicleNumberArray.join("") : "";

        setVehicleNumberType({
            vehicleNumberPrefix: vehicleNumberPrefixValue,
            vehicleNumberSuffix: vehicleNumberSuffixValue,
        });

    }, [open]);

    useEffect(() => {

        if (vehicle.profitLossMonthly) {
            setProfitLossData(vehicle.profitLossMonthly);
        }

    }, [vehicle.profitLossMonthly]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleCollapseClick = (key) => {
        setCollapseKeys({ [key]: collapseKeys[key] ? false : true });
    }

    const handleViewPdf = (item) => {
        setPdfDialogOpen(true);
        setPdfMonthValue(item.pdfMonth);
    }

    const handleClosePdf = () => {
        setPdfDialogOpen(false);
    }

    return (
        <>
            {dialogOpen && <RightSideBar
                sideBarName="profit-and-loss-report"
                rightSideBarOpen={dialogOpen}
                sideBarTitle={'Profit and Loss Report'}
                sideBarType="truckBook"
                vehicleNumberValue={vehicleNumberType}
                truckType={singleTruck && singleTruck.vehicleBodyType ? singleTruck.vehicleBodyType : ""}
                handleSubmit={event => submit(event)}
                toggleRightSideBar={handleClose} >
                <div>
                    {profitLossData && profitLossData.lineItems && profitLossData.lineItems.length > 0 && profitLossData.lineItems.map((data, key) => (
                        < div style={{ marginBottom: 34 }}>
                            <div className={classes.divAlign}>
                                <div className={classes.divMonth}>{data.month}</div>
                                <div className={classes.divPdf} onClick={() => handleViewPdf(data)}>
                                    <div className={classes.mrV1}><PictureAsPdfIcon /></div>
                                    <div>View PDF</div>
                                </div>
                            </div>
                            <Card className={classes.cardV1}>
                                <CardContent className={classes.cardContentV1}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            <div className={classes.divTitle}>Trip Started</div>
                                            <div className={classes.divValue}>{data.noOfTrips == 1 ? data.noOfTrips + ' Trip' : data.noOfTrips + " Trips"}</div>
                                        </div>
                                        <div>
                                            <div className={classes.divTitle}>Last Trip KM</div>
                                            <div className={classes.divValue}>{data.kmReading ? data.kmReading : '--'}</div>
                                        </div>
                                        <div>
                                            <div className={classes.divTitle}>Refuel Qty.</div>
                                            <div className={classes.divValue}>{data.refuelQuantity ? data.refuelQuantity : '--'}</div>
                                        </div>
                                    </div>

                                    <hr className={classes.hrV1} />

                                    <div>
                                        {data.revenueItems && data.revenueItems.length == 0 &&
                                            <div className={classes.divAlign}>
                                                <div className={classes.divTitle}>Revenue</div>
                                                <div className={classes.divValueV1}>{numberFormat(data.totalRevenue)}</div>
                                            </div>
                                        }
                                        {data.revenueItems && data.revenueItems.length > 0 &&
                                            <Accordion classes={{ root: classes.boxShadow }} onChange={() => handleCollapseClick(`revenue${key}collapse`)}>
                                                <AccordionSummary
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    classes={{ content: classes.divCenter, root: classes.rootV1 }}
                                                >
                                                    <div className={classes.divAlignV1}>
                                                        <div className={classes.dFlex}>
                                                            <div className={classes.divTitle}>Revenue</div>
                                                            {collapseKeys && collapseKeys[`revenue${key}collapse`] ?
                                                                <ArrowDropUpIcon className={classes.arrowUpV1} />
                                                                :
                                                                <ArrowDropDownIcon className={classes.arrowDownV1} />
                                                            }
                                                        </div>
                                                        <div className={classes.divValueV1}>{numberFormat(data.totalRevenue)}</div>
                                                    </div>
                                                </AccordionSummary>
                                                <AccordionDetails classes={{ root: classes.pdV1 }}>
                                                    <div className={classes.divItems}>
                                                        {data.revenueItems.map((revenue) => (
                                                            <div className={classes.divAlignV2}>
                                                                <div className={classes.divAlignV3}>
                                                                    <div>{revenue.startDate}</div>
                                                                    <span className={classes.bullet}>•</span>
                                                                    <div>{revenue.originLocation}&nbsp;-&nbsp;{revenue.destinationLocation} </div>
                                                                </div>
                                                                <div>{numberFormat(revenue.amount)}</div>
                                                            </div>
                                                        ))
                                                        }
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        }
                                    </div>

                                    <div className={classes.mtV1}>
                                        {data.expenseItems && data.expenseItems.length == 0 && data.hiredExpenseItems && data.hiredExpenseItems.length == 0 &&
                                            <div className={classes.divAlign}>
                                                <div className={classes.divTitle}>Expenses</div>
                                                <div className={classes.fw300}>{numberFormat(data.totalExpenses)}</div>
                                            </div>
                                        }
                                        {data.expenseItems && data.expenseItems.length > 0 &&
                                            <Accordion classes={{ root: classes.boxShadow }} onChange={() => handleCollapseClick(`expenses${key}collapse`)}>
                                                <AccordionSummary
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    classes={{ content: classes.divCenter, root: classes.rootV1 }}
                                                >
                                                    <div className={classes.divAlignV1}>
                                                        <div className={classes.dFlex}>
                                                            <div className={classes.divTitle}>Expenses</div>
                                                            {collapseKeys && collapseKeys[`expenses${key}collapse`] ?
                                                                <ArrowDropUpIcon className={classes.arrowUpV1} />
                                                                :
                                                                <ArrowDropDownIcon className={classes.arrowDownV1} />
                                                            }
                                                        </div>
                                                        <div className={classes.fw300}>{numberFormat(data.totalExpenses)}</div>
                                                    </div>
                                                </AccordionSummary>
                                                <AccordionDetails classes={{ root: classes.pdV1 }}>
                                                    <div className={classes.divItems}>
                                                        {data.expenseItems.map((expense) => (
                                                            <div className={classes.divAlignV2}>
                                                                <div>
                                                                    {expense.displayName}
                                                                </div>
                                                                <div>{numberFormat(expense.amount)}</div>
                                                            </div>
                                                        ))
                                                        }
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        }
                                        {data.hiredExpenseItems && data.hiredExpenseItems.length > 0 &&
                                            <Accordion classes={{ root: classes.boxShadow }} onChange={() => handleCollapseClick(`expenses${key}collapse`)}>
                                                <AccordionSummary
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    classes={{ content: classes.divCenter, root: classes.rootV1 }}
                                                >
                                                    <div className={classes.divAlignV1}>
                                                        <div className={classes.dFlex}>
                                                            <div className={classes.divTitle}>Expenses</div>
                                                            {collapseKeys && collapseKeys[`expenses${key}collapse`] ?
                                                                <ArrowDropUpIcon className={classes.arrowUpV1} />
                                                                :
                                                                <ArrowDropDownIcon className={classes.arrowDownV1} />
                                                            }
                                                        </div>
                                                        <div className={classes.divValueV1}>{numberFormat(data.totalExpenses)}</div>
                                                    </div>
                                                </AccordionSummary>
                                                <AccordionDetails classes={{ root: classes.pdV1 }}>
                                                    <div className={classes.divItems}>
                                                        {data.hiredExpenseItems.map((expense) => (
                                                            <div className={classes.divAlignV2}>
                                                                <div className={classes.divAlignV3}>
                                                                    <div>{expense.startDate}</div>
                                                                    <span className={classes.bullet}>•</span>
                                                                    <div>{expense.originLocation}&nbsp;-&nbsp;{expense.destinationLocation} </div>
                                                                </div>
                                                                <div>{numberFormat(expense.amount)}</div>
                                                            </div>
                                                        ))
                                                        }
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        }
                                    </div>

                                    <hr className={classes.colorV2} />

                                    <div className={classes.divAlign}>
                                        <div className={classes.divProfit}>Profit</div>
                                        {data.profit > 0 &&
                                            <div className={classes.profit}>{numberFormat(data.profit)}</div>
                                        }
                                        {data.profit < 0 &&
                                            <div className={classes.loss}>-<span className={classes.mlV5}>{numberFormat(data.profit * -1)}</span></div>
                                        }
                                        {
                                            data.profit == 0 &&
                                            <div className={classes.loss}>{numberFormat(data.profit)}</div>
                                        }
                                    </div>

                                </CardContent>
                            </Card>
                        </div>
                    ))
                    }
                </div>
            </RightSideBar >}
            {
                pdfDialogOpen &&
                <ReportsDialog open={pdfDialogOpen} name={"Truck Monthly Profit & Loss"} vehicleIdValue={vehicleId} pdfMonth={pdfMonthValue} onClose={handleClosePdf} />
            }
        </>
    );

}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetMonthlyProfitLoss: (data, onSuccess, onFailure) => dispatch(vehicleMonthlyPnlReport(data, onSuccess, onFailure)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleVehicleMonthlyReport);
